<template>
  <div class="dynamic-tables">
    <div v-if="showLoading" class="text-center">
      <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
      <p id="cancel-label">Sedang memuat data...</p>
    </div>
    <div v-if="!showLoading">
      <h2 class="page-title">Early Warning Permohonan Nonberusaha {{ tipe_pemohon }}</h2>
      <Widget customHeader>
        <div class="d-flex justify-content-between">
          <div></div>
          <div class="d-flex">
            <div class="d-flex">
              <div class="d-flex align-items-center mr-2">
                <label for="search" class="mr-2 mb-0">Search: </label>
                <input v-model="search.value" type="text" class="form-control" id="search" />
              </div>
              <div>
                <select v-model="search.field" class="form-control">
                  <option value="instansi_pemohon">Nama Pemohon</option>
                  <option value="nomor_kkp">Nomor Penerbitan</option>
                  <option value="tanggal_ttd_mkp">Tgl. Penerbitan</option>
                  <option value="masa_berlaku">Masa Berlaku</option>
                </select>
              </div>
            </div>
            <div class="d-flex ml-4">
              <div class="d-flex align-items-center mr-2">
                <label for="search" class="mb-0">Sort By: </label>
              </div>
              <div>
                <select v-model="sort.field" class="form-control">
                  <option value="createdAt">Tgl. Submit</option>
                  <option value="tanggal_ttd_mkp">Tgl. Penerbitan</option>
                  <option value="masa_berlaku">Masa Berlaku</option>
                </select>
              </div>
              <div class="ml-2">
                <select v-model="sort.direction" class="form-control">
                  <option value="DESC">DESC</option>
                  <option value="ASC">ASC</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table id="tableEarlyWarning" class="table" style="width: 100%">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Pemohon</th>
                <th>Nomor Penerbitan</th>
                <th>Tgl. Penerbitan</th>
                <th>Masa Berlaku</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in dataPermohonan" :key="index">
                <!-- No -->
                <td>
                  {{ index + pagination.firstInPage }}
                </td>
                <!-- Nama Pemohon -->
                <td>
                  {{ row.instansi_pemohon }}
                </td>
                <!-- Nomor Penerbitan -->
                <td>
                  {{ row.nomor_kkp }}
                </td>
                <!-- Tgl. Penerbitan -->
                <td>
                  {{ row.tanggal_ttd_mkp ? formatDate(row.tanggal_ttd_mkp, 'DD MMMM YYYY') : '-' }}
                </td>
                <!-- Masa Berlaku -->
                <td>
                  {{ row.masa_berlaku ? formatDate(row.masa_berlaku, 'DD MMMM YYYY') : '-' }}
                </td>
                <!-- Aksi -->
                <td>
                  <div>
                    <b-button-toolbar>
                      <b-button size="sm" variant="warning" class="text-white m-1" @click="showModalRekomendasi(row)">
                        <i class="fa fa-pencil-square-o"></i> Buat Rekomendasi
                      </b-button>
                      <b-button size="sm" variant="primary" class="text-white m-1" @click="sendReminder(row)">
                        <i class="fa fa-envelope-o"></i> Kirim Pengingat
                      </b-button>
                    </b-button-toolbar>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- prettier-ignore -->
        <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ?
              pagination.limit * pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
          </template>
        </div>
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'first' })">
                <span aria-hidden="true">Awal</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'prev' })">
                <span aria-hidden="true">Sebelumnya</span>
              </a>
            </li>
            <li v-for="i in pagination.pageNumber" class="page-item">
              <a :class="['page-link', { 'active': i === `${pagination.currentPage}` }]" href="#"
                @click="changePage({ page: i })">{{ i }}</a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'next' })">
                <span aria-hidden="true">Selanjutnya</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'last' })">
                <span aria-hidden="true">Akhir</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
      </Widget>

      <b-modal id="modal-rekomendasi" title="Buat Rekomendasi" size="md">
        <template>
          <b-form>
            <div class="row g-0">
              <div class="col-12">
                <label for="jenis_rekomendasi"> Jenis Rekomendasi <span class="text-danger">*</span> </label>
                <v-select
                  id="jenis_rekomendasi"
                  v-model="formRekomendasi.jenis_rekomendasi"
                  :options="['Habis Masa Berlaku', 'Pencabutan', 'Pembatalan']"
                  name="Jenis Rekomendasi"
                  v-validate="'required'"
                />
                <span class="text-danger" v-if="errors.has('Jenis Rekomendasi')">
                  {{ errors.first('Jenis Rekomendasi') }}
                </span>
              </div>
              <div class="col-12 mt-3">
                <label for="file_rekomendasi">
                  <template v-if="formRekomendasi.jenis_rekomendasi === 'Habis Masa Berlaku'">
                    File Rekomendasi Habis Masa Berlaku
                  </template>
                  <template v-if="formRekomendasi.jenis_rekomendasi === 'Pencabutan'">
                    File Rekomendasi Pencabutan
                  </template>
                  <template v-if="formRekomendasi.jenis_rekomendasi === 'Pembatalan'">
                    File Rekomendasi Pembatalan
                  </template>
                  <span class="text-danger">*</span>
                </label>
                <InputFile
                  id="file_rekomendasi"
                  v-model="formRekomendasi.file_rekomendasi"
                  name="File Rekomendasi"
                  accept=".pdf"
                  v-validate="'required'"
                />
                <span class="text-danger" v-if="errors.has('File Rekomendasi')">
                  {{ errors.first('File Rekomendasi') }}
                </span>
              </div>
              <div class="col-12 mt-3">
                <label for="nomor_surat_permohonan"> Nomor Surat <span class="text-danger">*</span> </label>
                <b-form-input
                  id="nomor_surat_permohonan"
                  v-model="formRekomendasi.nomor_surat_permohonan"
                  v-validate="'required'"
                  name="Nomor Surat"
                ></b-form-input>
                <span class="text-danger" v-if="errors.has('Nomor Surat')">
                  {{ errors.first('Nomor Surat') }}
                </span>
              </div>
              <div v-if="formRekomendasi.jenis_rekomendasi === 'Pembatalan'" class="col-12 mt-3">
                <label for="perihal_surat_permohonan"> Perihal Surat <span class="text-danger">*</span> </label>
                <b-form-input
                  id="perihal_surat_permohonan"
                  v-model="formRekomendasi.perihal_surat_permohonan"
                  v-validate="'required'"
                  name="Perihal Surat"
                ></b-form-input>
                <span class="text-danger" v-if="errors.has('Perihal Surat')">
                  {{ errors.first('Perihal Surat') }}
                </span>
              </div>
              <div class="col-lg-12 mt-3">
                <label for="tanggal_surat_permohonan"> Tanggal Surat <span class="text-danger">*</span> </label>
                <b-form-input
                  type="date"
                  id="tanggal_surat_permohonan"
                  v-model="formRekomendasi.tanggal_surat_permohonan"
                  v-validate="'required'"
                  name="Tanggal Surat"
                ></b-form-input>
                <span class="text-danger" v-if="errors.has('Tanggal Surat')">
                  {{ errors.first('Tanggal Surat') }}
                </span>
              </div>
            </div>
          </b-form>
        </template>
        <template #modal-footer>
          <div class="w-100">
            <b-button variant="primary" size="sm" class="float-right" @click="submitRekomendasi" :disabled="isLoading">
              <img src="../../../assets/icons/archive.svg" />
              Simpan
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget'
import axios from 'axios'
import InputFile from '../Components/InputFile.vue'
import vSelect from 'vue-select'
import { formatDate, getDateFromNowMonths } from '../../../helper/helpernew'
import { Validator } from 'vee-validate'
import Swal from 'sweetalert2'

export default {
  components: { Widget, InputFile, vSelect },
  props: ['tipe_pemohon'],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      dataPermohonan: [],
      formRekomendasi: {
        jenis_rekomendasi: 'Habis Masa Berlaku',
        file_rekomendasi: null,
        nomor_surat_permohonan: null,
        perihal_surat_permohonan: null,
        tanggal_surat_permohonan: null,
      },

      selectedData: null,
      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: 'instansi_pemohon',
        value: '',
      },
      sort: {
        field: 'createdAt',
        direction: 'DESC',
      },
      debounceTerm: null,
      isLoading: false,
      showLoading: false,
    }
  },
  methods: {
    async getdata() {
      $('#tableEarlyWarning').DataTable().destroy()
      return this.loaddata()
    },

    async loaddata() {
      this.showLoading = true
      this.dataPermohonan = []
      const nextMonth = getDateFromNowMonths(3)

      // prettier-ignore
      const api = `api/ref/getPermohonan/Nonberusaha`+
        `?page=${this.pagination.currentPage}`+
        `&filter=keterangan_status,=,Terbit;masa_berlaku,<=,${nextMonth};tipe_pemohon,=,${this.tipe_pemohon}`+
        `${this.search.value!==''?`;${this.search.field},${this.search.field==='tanggal_proses'||this.search.field==='tanggal_pada_permohonan'?'>=':'like'},${this.search.value}`:''}`+
        `&sort=${this.sort.field},${this.sort.direction}`
      return axios
        .get(this.baseapiPengendalian + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          const data = response.data
          this.pagination.limit = data.limit
          this.pagination.total = data.total
          this.pagination.firstInPage = (this.pagination.currentPage - 1) * data.limit + 1
          this.pagination.lastPage = Math.ceil(data.total / data.limit)
          this.setPagination()
          this.dataPermohonan = response.data.data
          this.initDatatable()
          this.showLoading = false
        })
    },

    async submitRekomendasi() {
      this.$validator.validateAll().then(async (res) => {
        if (res) {
          this.$loading(true)
          this.isLoading = true
          const { instansi_pemohon, nomor_kkp, tanggal_ttd_mkp, masa_berlaku, npwp_pemohon, nomor_permohonan } =
            this.selectedData
          const {
            jenis_rekomendasi,
            file_rekomendasi,
            nomor_surat_permohonan,
            perihal_surat_permohonan,
            tanggal_surat_permohonan,
          } = this.formRekomendasi

          const formData = new FormData()

          // prettier-ignore
          if (jenis_rekomendasi === 'Pembatalan') {
            formData.append('file_permohonan_pemuktahiran', file_rekomendasi)
            formData.append('nomor_surat_permohonan', nomor_surat_permohonan)
            formData.append('perihal_surat_permohonan', perihal_surat_permohonan)
            formData.append('tanggal_surat_permohonan', tanggal_surat_permohonan)
            formData.append('jenis_pemuktahiran', 'Pengembalian')
            formData.append('jenis_permohonan', 'Nonberusaha')
            formData.append('nomor_izin_terbit', nomor_kkp)
            formData.append('instansi_pemohon', instansi_pemohon)
            formData.append('npwp', npwp_pemohon)
            formData.append('nomor_permohonan', nomor_permohonan)
            formData.append('tanggal_penerbitan_izin', tanggal_ttd_mkp)
            formData.append('status_persetujuan', 'Terima')
            formData.append('status', 'Menunggu Jadwal Penilaian')
          } else {
            formData.append('jenis_permohonan', 'Nonberusaha')
            formData.append('nama_pemohon', instansi_pemohon)
            formData.append('nomor_izin_terbit', nomor_kkp)
            formData.append('tanggal_penerbitan', tanggal_ttd_mkp)
            formData.append('masa_berlaku', masa_berlaku)
            formData.append('nomor_surat_permohonan', nomor_surat_permohonan)
            formData.append('tanggal_surat_permohonan', tanggal_surat_permohonan)
            formData.append('status', 'Menunggu Jadwal Penilaian')
            if (jenis_rekomendasi === 'Habis Masa Berlaku') {
              formData.append('file_rekomendasi_habis_masa_berlaku', file_rekomendasi)
            } else {
              formData.append('file_rekomendasi_pencabutan', file_rekomendasi)
            }
          }

          let api = ''
          switch (jenis_rekomendasi) {
            case 'Habis Masa Berlaku':
              api = 'api/ref/createPermohonan/Habis'
              break
            case 'Pencabutan':
              api = 'api/ref/createPermohonan/Pencabutan'
              break
            case 'Pembatalan':
              api = 'api/ref/createPermohonan/Pemuktahiran'
              break
          }

          try {
            await axios.post(this.baseapiPengendalian + api, formData, this.getApiOption())
            this.$bvModal.hide('modal-rekomendasi')
            Swal.fire('Berhasil', 'Berhasil membuat rekomendasi', 'success')
            this.formRekomendasi = {
              jenis_rekomendasi: 'Habis Masa Berlaku',
              file_rekomendasi: null,
              nomor_surat_permohonan: null,
              perihal_surat_permohonan: null,
              tanggal_surat_permohonan: null,
            }
          } catch (error) {
            Swal.fire('Gagal', 'Gagal membuat rekomendasi', 'error')
          }
          this.$loading(false)
          this.isLoading = false
        }
      })
    },

    showModalRekomendasi(record) {
      this.selectedData = record
      this.$bvModal.show('modal-rekomendasi')
    },

    async sendReminder(record) {
      const { id, instansi_pemohon, nomor_kkp } = record
      const confirm = await Swal.fire({
        title: 'Kirim Email Pengingat',
        text: `Kirim email pengingat untuk Pemohon ${instansi_pemohon} dengan Nomor Penerbitan ${nomor_kkp}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, kirim',
        cancelButtonText: 'Batal',
      })
      if (!confirm.isConfirmed) return
      const formData = {
        id: id,
        jenis: 'Nonberusaha',
      }
      try {
        await axios.post(`${this.baseapiPengendalian}api/ref/sendReminder`, formData, this.getApiOption())
        Swal.fire('Berhasil', 'Email pengingat berhasil dikirim', 'success')
      } catch (error) {
        Swal.fire('Gagal', 'Email pengingat gagal dikirim', 'error')
      }
    },

    setPagination() {
      this.$router
        .replace({
          path: this.$route.path,
          query: { page: this.pagination.currentPage },
        })
        .catch((err) => {})

      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        if (config.page === '...') return
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getdata()
      $('html,body').scrollTop(1000)
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment('DD MMMM YYYY')
        var t = $('#tableEarlyWarning').DataTable({
          paging: false,
          info: false,
          filter: false,
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: 'Bfrtip',
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                return type == 'export' ? meta.row + 1 : data
              },
            },
          ],
          buttons: [],
        })
      }, 300)
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },

    formatDate,
  },
  mounted() {
    this.getdata()

    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getdata()
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getdata()
      },
      deep: true,
    },
  },
}
</script>
